import type { QueryClient } from '@tanstack/react-query';
import { invalidateRoots } from '@/lib/data-sync';

/**
 * A job notification (push or feed row) means the job changed server-side —
 * on another device, so lib/data-sync.ts (which covers this browser's own
 * writes) never saw it. Delegate to the same root map data-sync uses so
 * "which query families render a job" has exactly one source of truth:
 * driver list, dispatcher board, job detail, and catalogue items all refresh.
 *
 * Safe for cancelled/removed kinds too: the detail refetch 404s → null → the
 * page's "Job not found" state, which is the correct outcome for a job the
 * driver no longer has.
 */
export function invalidateJobData(qc: QueryClient): void {
  invalidateRoots(qc, ['/dispatch/jobs', '/dispatch-job-products']);
}
